import { render, staticRenderFns } from "./Copyright.vue?vue&type=template&id=589f9068&scoped=true"
import script from "./Copyright.vue?vue&type=script&lang=js"
export * from "./Copyright.vue?vue&type=script&lang=js"
import style0 from "./Copyright.vue?vue&type=style&index=0&id=589f9068&prod&scoped=true&lang=css"
import style1 from "./Copyright.vue?vue&type=style&index=1&id=589f9068&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589f9068",
  null
  
)

export default component.exports